export const payload = {
  receiveMutation: 'RECEIVE_SCS',
  receivingMutation: 'RECEIVING_SCS',
  receiveMetadataMutation: 'RECEIVE_SC_METADATA',
  savingMutation: 'SAVING_SC',
  incrementMutation: 'INCREMENT_SC_COUNT',
  updatingMutation: 'UPDATING_SC',
  deleteMutation: 'DELETE_SC',
  deletingMutation: 'DELETING_SC',
  resetMetaMutation: 'RESET_SC_META',
  clearMutation: 'CLEAR_SC_STATE',
  moduleName: 'sourcecode',
  endpoint: 'sourcecodes',
  searchableFields: ['code', 'name', 'description', 'active']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Sourcecodes/actionPayload.js